import React from 'react';
import { FloatingLabelInput } from '../common/FloatingLabelInput';

interface UsernameEmailGroupProps {
  username: string;
  setUsername: (value: string) => void;
  usernameStatus: 'default' | 'focus' | 'error' | 'success';
  usernameError: string;
  checkingUsername: boolean;
  usernameUnique: boolean | null;
  email: string;
  setEmail: (value: string) => void;
  emailStatus: 'default' | 'focus' | 'error' | 'success';
  emailError: string;
}

const UsernameEmailGroup: React.FC<UsernameEmailGroupProps> = ({
  username,
  setUsername,
  usernameStatus,
  usernameError,
  checkingUsername,
  usernameUnique,
  email,
  setEmail,
  emailStatus,
  emailError,
}) => (
  <div className="mb-4 space-y-1">
    <div className="mb-1 grid grid-cols-1 items-center md:grid-cols-[1fr_220px] md:gap-4">
      <div>
        <FloatingLabelInput
          label="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
          status={usernameStatus}
          className="mt-0 md:mt-1"
        />
      </div>
      <div className="mt-2 min-h-[32px] self-center text-xs md:mt-3 md:min-w-[220px] md:whitespace-nowrap md:text-left md:text-xs">
        {checkingUsername && username && (
          <span className="text-gray-500 dark:text-gray-400">Checking username...</span>
        )}
        {!checkingUsername && usernameUnique && username && (
          <span className="text-green-500 dark:text-green-400">&#10004;</span>
        )}
        {usernameError && username && (
          <span className="text-red-500 dark:text-red-400">&#9888; {usernameError}</span>
        )}
      </div>
    </div>
    <div className="mb-1 grid grid-cols-1 items-center md:grid-cols-[1fr_220px] md:gap-4">
      <div>
        <FloatingLabelInput
          label="Email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          status={emailStatus}
          className="mt-0 md:mt-3"
        />
      </div>
      <div className="mt-2 min-h-[32px] self-center text-xs md:mt-3 md:min-w-[220px] md:whitespace-nowrap md:text-left md:text-xs">
        {email && !emailError && (
          <span className="text-green-500 dark:text-green-400">&#10004;</span>
        )}
        {emailError && <span className="text-red-500 dark:text-red-400">&#9888; {emailError}</span>}
      </div>
    </div>
  </div>
);

export default UsernameEmailGroup;
